var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper" },
        [_c("PageHeader", { attrs: { id: "Basic", title: "Basic" } })],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.infoLoading,
              expression: "infoLoading",
            },
          ],
          staticClass: "basic-info table-wrapper",
          attrs: { "element-loading-text": "Loading..." },
        },
        [
          _c("div", { staticClass: "avatar-info" }, [
            _c(
              "div",
              { staticClass: "avatar-name" },
              [
                _c("el-avatar", {
                  staticStyle: { "flex-shrink": "0" },
                  attrs: { shape: "square", size: "large", src: _vm.AvatarURL },
                }),
                _c("div", { staticClass: "name-status" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.info.SEName))]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        position: "relative",
                      },
                    },
                    [
                      _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "5px" },
                          attrs: {
                            size: "mini",
                            effect: "dark",
                            type: _vm.tagTypeParser(_vm.info.emslStatus),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.tagLabelParser(_vm.info.emslStatus)) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "role",
                              rawName: "v-role",
                              value: [1, 2, 3, 13],
                              expression: "[1,2,3,13]",
                            },
                          ],
                        },
                        [
                          _vm.info.Types && _vm.typeList.length > 0
                            ? [
                                _vm.editType
                                  ? _c(
                                      "el-select",
                                      {
                                        staticClass: "type-select",
                                        attrs: {
                                          disable: _vm.role == 1,
                                          multiple: "",
                                          placeholder: "请选择",
                                        },
                                        on: {
                                          change: _vm.onTypeChange,
                                          "visible-change": _vm.handChange,
                                        },
                                        model: {
                                          value: _vm.info.Types,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.info, "Types", $$v)
                                          },
                                          expression: "info.Types",
                                        },
                                      },
                                      _vm._l(_vm.typeList, function (item) {
                                        return _c("el-option", {
                                          key: item.TypeID,
                                          attrs: {
                                            value: item.TypeID,
                                            label: item.TypeDesc,
                                            disabled: item.disabled,
                                          },
                                        })
                                      }),
                                      1
                                    )
                                  : _vm._l(_vm.info.Types, function (item, i) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: i,
                                          staticStyle: {
                                            "margin-right": "5px",
                                          },
                                          attrs: {
                                            size: "mini",
                                            effect: "dark",
                                            type: "info",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("typeName")(
                                                  item,
                                                  _vm.typeList
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "hcp-tag-wrap" },
              [
                _c("div", { staticClass: "hcp-tag-label" }, [_vm._v("Tag")]),
                _c("hcp-tag-select", {
                  attrs: {
                    "bind-owner": "",
                    "owner-user-id": _vm.info.MLID || "",
                  },
                  model: {
                    value: _vm.selectedTagIds,
                    callback: function ($$v) {
                      _vm.selectedTagIds = $$v
                    },
                    expression: "selectedTagIds",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", icon: "iconfont icon-qrcode" },
                    on: { click: _vm.getQRCode },
                  },
                  [_vm._v(" QR Code ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "mini",
                      icon: "el-icon-plus",
                      type: "primary",
                      disabled: _vm.disabled || _vm.isAdmin,
                    },
                    on: {
                      click: function ($event) {
                        _vm.combinePushDialogVisible = true
                      },
                    },
                  },
                  [_vm._v(" New Push ")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "focus-area" },
            [
              _c("h4", [_vm._v("Engagement Profile ")]),
              _c("el-input", {
                attrs: {
                  maxlength: "500",
                  "show-limit-number": "",
                  type: "textarea",
                  rows: 3,
                },
                model: {
                  value: _vm.focus,
                  callback: function ($$v) {
                    _vm.focus = $$v
                  },
                  expression: "focus",
                },
              }),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", disabled: _vm.isAdmin },
                      on: { click: _vm.resetFocus },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "danger",
                        plain: "",
                        disabled: _vm.isAdmin,
                      },
                      on: { click: _vm.setFocus },
                    },
                    [_vm._v(" Save ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "profile-detail" }, [
            _c("div", [
              _c("strong", [_vm._v("Province")]),
              _c("p", [
                _c("span", {
                  attrs: { title: _vm.info.Province },
                  domProps: { textContent: _vm._s(_vm.info.Province) },
                }),
              ]),
            ]),
            _c("div", [
              _c("strong", [_vm._v("City")]),
              _c("p", [
                _c("span", {
                  attrs: { title: _vm.info.City },
                  domProps: { textContent: _vm._s(_vm.info.City) },
                }),
              ]),
            ]),
            _c("div", [
              _c("strong", [_vm._v("Hospital / Institution")]),
              _c("p", [
                _c("span", {
                  attrs: { title: _vm.info.Hospital },
                  domProps: { textContent: _vm._s(_vm.info.Hospital) },
                }),
              ]),
            ]),
            _c("div", [
              _c("strong", [_vm._v("Department")]),
              _c("p", [
                _c("span", {
                  attrs: { title: _vm.info.Department },
                  domProps: { textContent: _vm._s(_vm.info.Department) },
                }),
              ]),
            ]),
            _c("div", [
              _c("strong", [_vm._v("Phone")]),
              _c("p", [
                !_vm.editingPhone
                  ? _c("span", [
                      _c("span", {
                        attrs: { title: _vm.info.Phone },
                        domProps: { textContent: _vm._s(_vm.info.Phone) },
                      }),
                      !_vm.canNotEditPhone
                        ? _c(
                            "i",
                            {
                              staticClass: "el-icon-edit-outline",
                              staticStyle: {
                                color: "#409eff",
                                cursor: "pointer",
                              },
                              on: { click: _vm.editPhone },
                            },
                            [_vm._v("Edit")]
                          )
                        : _vm._e(),
                    ])
                  : _c(
                      "span",
                      { staticClass: "edit-input" },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "Input phone" },
                          model: {
                            value: _vm.info.Phone,
                            callback: function ($$v) {
                              _vm.$set(_vm.info, "Phone", $$v)
                            },
                            expression: "info.Phone",
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              plain: "",
                              loading: _vm.editPhoneLoading,
                            },
                            on: { click: _vm.savePhone },
                          },
                          [_vm._v(" Save ")]
                        ),
                      ],
                      1
                    ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "table-wrapper el-collapse-wrapper" },
        [
          _c(
            "el-collapse",
            {
              model: {
                value: _vm.collapse,
                callback: function ($$v) {
                  _vm.collapse = $$v
                },
                expression: "collapse",
              },
            },
            [
              !_vm.isAdmin
                ? _c(
                    "el-collapse-item",
                    { attrs: { name: "PushedContent" } },
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          _c("PageHeader", {
                            attrs: {
                              id: "PushedContent",
                              title: "Pushed Content",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("PushedContent", {
                        ref: "pushedContent",
                        staticClass: "padding-lr",
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-collapse-item",
                { attrs: { name: "TextMessage" } },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("PageHeader", {
                        attrs: { id: "TextMessage", title: "Messages" },
                      }),
                    ],
                    1
                  ),
                  _c("TextMessage", {
                    ref: "textMessage",
                    staticClass: "padding-lr",
                  }),
                ],
                2
              ),
              !_vm.isAdmin
                ? _c(
                    "el-collapse-item",
                    { attrs: { name: "PaperComments" } },
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          _c("PageHeader", {
                            attrs: {
                              id: "PaperComments",
                              title: "Paper Comments",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("PaperComments", {
                        ref: "paperComments",
                        staticClass: "padding-lr",
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              !_vm.isAdmin
                ? _c(
                    "el-collapse-item",
                    { attrs: { name: "FullArticleRequests" } },
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          _c("PageHeader", {
                            attrs: {
                              id: "FullArticleRequests",
                              title: "Full Article Requests",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("FullArticleRequests", {
                        ref: "fullArticleRequests",
                        staticClass: "padding-lr",
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-collapse-item",
                { attrs: { name: "6" } },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [_c("PageHeader", { attrs: { title: "Certification" } })],
                    1
                  ),
                  _c("Certification", {
                    ref: "cert",
                    staticClass: "padding-lr",
                    on: { success: _vm.onSuccess },
                  }),
                ],
                2
              ),
              _c(
                "el-collapse-item",
                { attrs: { name: "OperationLog" } },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("PageHeader", {
                        attrs: {
                          id: "OperationLog",
                          title: "Operation History",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("OperationLog", {
                    ref: "operationLog",
                    staticClass: "padding-lr",
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CombinePushDialog", {
        attrs: { visible: _vm.combinePushDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.combinePushDialogVisible = $event
          },
          success: _vm.onSuccess,
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
      _c("NewPushDialog", {
        attrs: { visible: _vm.newPushDialogVisible, seId: _vm.info.SEID },
        on: {
          "update:visible": function ($event) {
            _vm.newPushDialogVisible = $event
          },
          "update:seId": function ($event) {
            return _vm.$set(_vm.info, "SEID", $event)
          },
          "update:se-id": function ($event) {
            return _vm.$set(_vm.info, "SEID", $event)
          },
          success: _vm.onSuccess,
        },
      }),
      _c("QRCodeDialog", {
        attrs: {
          visible: _vm.qrcodeDialogVisible,
          data: _vm.rowData,
          title: _vm.qrTitle,
        },
        on: {
          "update:visible": function ($event) {
            _vm.qrcodeDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }